import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import {BrowserRouter as Router, Routes, Route} from "react-router-dom";
import Wordmenu from "./components/Wordmenu";

function App() {
  return (
      <>
        <Router basename="/ion-english">
            <Routes>
                <Route path='/' element={<Wordmenu/>}/>
            </Routes>
        </Router>
      </>
  );
}

export default App;
